"use strict";

var _interopRequireDefault = require("/opt/build/repo/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/opt/build/repo/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/opt/build/repo/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _utils = require("@/utils");

var _role = require("@/api/role");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultRole = {
  id: '',
  displayName: '',
  role: '',
  status: false,
  password: '',
  name: ''
};
var listQuery = {
  id: undefined,
  role: undefined,
  displayName: undefined,
  status: undefined
};
var _default = {
  name: 'AccountList',
  data: function data() {
    return {
      administrator: Object.assign({}, defaultRole),
      password1: '',
      routes: [],
      administrators: [],
      dialogVisible: false,
      dialogType: 'new',
      listQuery: this.$_.clone(listQuery),
      total: 0,
      page: 1,
      limit: 20,
      roleOptions: [],
      statusOptions: [{
        name: '启用',
        value: true
      }, {
        name: '禁用',
        value: false
      }],
      defaultProps: {
        children: 'children',
        label: 'title'
      }
    };
  },
  created: function created() {
    this.getAdministrators();
  },
  methods: {
    getAdministrators: function () {
      var _getAdministrators2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.listQuery), {}, {
                  skip: (this.page - 1) * this.limit,
                  limit: this.limit
                });
                _context.next = 3;
                return (0, _role.getAdministrators)(params);

              case 3:
                res = _context.sent;
                this.administrators = res.data.administrators;
                this.total = res.data.total;
                this.roleOptions = this.administrators.map(function (item) {
                  return {
                    name: item.roleName,
                    value: item.id
                  };
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAdministrators() {
        return _getAdministrators2.apply(this, arguments);
      }

      return getAdministrators;
    }(),
    comRole: function comRole(role) {
      var comRole = '';
      this.roleOptions.forEach(function (ele) {
        if (ele.value === role) {
          comRole = ele.name;
        }
      });
      return comRole;
    },
    handleAddAdministrator: function handleAddAdministrator() {
      this.password1 = '';
      this.administrator = Object.assign({}, defaultRole);
      this.dialogType = 'new';
      this.dialogVisible = true;
    },
    handleEdit: function handleEdit(scope) {
      console.log('scope :', scope.row);
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.administrator = (0, _utils.deepClone)(scope.row);
      this.password1 = this.administrator.password;
    },
    confirmRole: function () {
      var _confirmRole = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var isEdit, isEqual, index, _yield$addAdministrat, data, _this$administrator, id, name;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isEdit = this.dialogType === 'edit';
                isEqual = this.administrator.password !== this.password1;

                if (!isEqual) {
                  _context2.next = 5;
                  break;
                }

                this.$notify({
                  title: '错误',
                  message: '两次密码不相等',
                  type: 'warning'
                });
                return _context2.abrupt("return");

              case 5:
                if (!isEdit) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 8;
                return (0, _role.updateAdministrator)(this.administrator.id, this.administrator);

              case 8:
                index = 0;

              case 9:
                if (!(index < this.administrators.length)) {
                  _context2.next = 16;
                  break;
                }

                if (!(this.administrators[index].id === this.administrator.id)) {
                  _context2.next = 13;
                  break;
                }

                this.administrators.splice(index, 1, Object.assign({}, this.administrator));
                return _context2.abrupt("break", 16);

              case 13:
                index++;
                _context2.next = 9;
                break;

              case 16:
                _context2.next = 24;
                break;

              case 18:
                _context2.next = 20;
                return (0, _role.addAdministrator)(this.administrator);

              case 20:
                _yield$addAdministrat = _context2.sent;
                data = _yield$addAdministrat.data;
                this.administrator.id = data.id;
                this.administrators.push(this.administrator);

              case 24:
                _this$administrator = this.administrator, id = _this$administrator.id, name = _this$administrator.name;
                this.dialogVisible = false;
                this.$notify({
                  title: 'Success',
                  dangerouslyUseHTMLString: true,
                  message: "\n            <div>\u89D2\u8272 ID: ".concat(id, "</div>\n            <div>\u89D2\u8272 \u540D\u5B57: ").concat(name, "</div>\n          "),
                  type: 'success'
                });

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function confirmRole() {
        return _confirmRole.apply(this, arguments);
      }

      return confirmRole;
    }(),
    handleStatus: function () {
      var _handleStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(row, status) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _role.updateAdministrator)(row.row.id, {
                  status: status
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function handleStatus(_x, _x2) {
        return _handleStatus.apply(this, arguments);
      }

      return handleStatus;
    }(),
    updateLimit: function updateLimit(val) {
      this.limit = val;
      this.handleFilter();
    },
    handleFilter: function handleFilter() {
      this.page = 1;
      this.getAdministrators();
    },
    resetForm: function resetForm() {
      this.listQuery = this.$_.clone(listQuery);
      this.handleFilter();
    }
  }
};
exports.default = _default;